module.exports = __webpack_public_path__ + "img/TGHLogoWhite.8941f6fd.png";